export default {
  header: 'Select specification to load',
  hint: 'Not all sensors are mapped for this equipment',
};
